import { createSelector } from 'reselect';
import noop from 'lodash/noop';
import type { State } from '../../reducers/types.tsx';
import type { IssueTransitionModal } from '../../reducers/ui/issue-transition/types.tsx';

const getUiIssueTransitionModal = (state: State) => state.ui.issueTransitionModal;

export const isIssueTransitionModalOpen = (state: State): boolean =>
	Boolean(getUiIssueTransitionModal(state)?.isOpen);

const getSelectedIssueActionPayload = (state: State): IssueTransitionModal | undefined =>
	getUiIssueTransitionModal(state);

const noSelectedIssue = { issueId: '', issueKey: '', transitionId: '' };
export const getPayloadForIssueTransitionModal = createSelector(
	[getSelectedIssueActionPayload],
	(issuePayload) => {
		if (issuePayload?.isOpen) {
			return {
				issueId: issuePayload.issueId,
				issueKey: issuePayload.issueKey,
				transitionId: issuePayload.transitionId,
			};
		}

		return noSelectedIssue;
	},
);

const noHandlers = { onDialogCancel: noop, onDialogError: noop, onDialogSuccess: noop };
export const getHandlersForIssueTransitionModal = createSelector(
	[getSelectedIssueActionPayload],
	(issuePayload) => {
		if (issuePayload?.isOpen) {
			const { onDialogCancel = noop, onDialogError = noop, onDialogSuccess = noop } = issuePayload;
			return {
				onDialogCancel,
				onDialogError,
				onDialogSuccess,
			};
		}

		return noHandlers;
	},
);
